export default "__VITE_ASSET__6c9fb12e__"